// Typings for the Higher Order Function (HOC)
import { ApiErrorInstance, isApiError } from '~/api/ApiResponse.ts';
import { getLocalizedString } from '~/i18n/utils.ts';
import logger from '~/utils/logger';

export type HandlerFunctionArgs = {
  error: ApiErrorInstance | Error;
  intl: any; // You might want to replace `any` with a more specific type
  params?: Record<string, any>;
};

export type HandlerFunction = (args: HandlerFunctionArgs) => string | undefined;

type WithHandleError = (
  handlerFunction: HandlerFunction
) => (args: HandlerFunctionArgs) => string;

// HOC implementation
const withHandleError: WithHandleError = (handlerFunction) => {
  return (args) => {
    const message = isApiError(args.error)
      ? handlerFunction(args)
      : args.error instanceof Error
        ? args.error.message
        : undefined;
    if (message) {
      return message;
    }
    const { error, intl } = args;
    // @todo log exception to cloud
    logger.error(error);
    return getLocalizedString('server_errors.generic', {
      intl
    });
  };
};

export { withHandleError };
